module.exports = __webpack_public_path__ + "static/media/gustavo-barros.f9053f4e.jpeg";